<div *ngIf="visibleWizard && steps && steps.length && this.data?.model" class="pt-3">
    <p *ngIf="data?.title">{{data.title}}</p>
    <p *ngIf="!data?.title"></p>
    <div class="d-flex align-items-center justify-content-between">
        <ng-container *ngFor="let step of steps; let i=index;">
            <ng-container *ngIf="!helpersService.isRenewal && i < (steps.length - 2) && i > 0">
                <div class="custom-progress-bar" [class.filled]="i <= currentStep"></div>
            </ng-container>
            <ng-container *ngIf="helpersService.isRenewal">
                <div class="custom-progress-bar" [class.filled]="i <= currentStep"></div>
            </ng-container>
        </ng-container> 
    </div>
</div>